/* eslint-disable import/named */
import {
  PREDICTION_ALL,
  PREDICTION_GET,
  PREDICTION_PUT,
  PREDICTION_DEL,
  PREDICTION_POST,
  PREDICTION_ERROR,
} from '../../actions/types'

const initialState = {
  log: null,
  isLoading: false,
}
export default function (state = initialState, action) {
  switch (action.type) {
    case PREDICTION_ALL:
      return {
        arr: [...action.payload],
        isLoading: true,
      }
    case PREDICTION_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case PREDICTION_POST:
      return action.payload
    case PREDICTION_PUT:
      return action.payload
    case PREDICTION_DEL:
      return { isLoading: true }
    default:
      return state
  }
}
